import React, {createContext, PropsWithChildren, useEffect, useState} from 'react';
import {fromPairs} from 'lodash';

import {LoadingView} from '../../components/loading/loading';

export type ResourceConfigurationContextValue = {
    [key: string]: string
    // Add more keys here
    Scope: string
    ClientID: string
}

export const ResourceConfigurationContext = createContext<ResourceConfigurationContextValue>(null as any);

type Props = PropsWithChildren<{
    configKeys: Array<string>
    getConfigurationItem: (key: string) => Promise<string>
}>

export const ResourceConfigurationProvider = ({ children, configKeys, getConfigurationItem }: Props) => {
    const [config, setConfig] = useState<ResourceConfigurationContextValue>(null as any);

    const loadConfigItems = () => {
        return Promise.all(
            configKeys.map(async key => {
                const value = await getConfigurationItem(key);
                return [key, value];
            })
        );
    };

    useEffect(() => {
        loadConfigItems()
            .then(results => {
                setConfig(fromPairs(results) as any);
            })
            .catch(error => {
                // TODO provide error screen / retry button
                console.error(error);
            });
    }, []);

    return <ResourceConfigurationContext.Provider value={config}>
        {config === null ? <LoadingView/> : children}
    </ResourceConfigurationContext.Provider>;
};
